import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ViewType = 'grid' | 'list'

interface ViewModeState {
  viewMode: ViewType
  setViewMode: (viewMode: ViewType) => void
}

export const useViewMode = create<ViewModeState>()(
  persist(
    set => ({
      viewMode: 'grid',
      setViewMode: (viewMode: ViewType) => set({ viewMode }),
    }),
    {
      name: 'qse-view-mode', // localStorage key
    },
  ),
)
